export const inputModel = {
  'input': 'fe-input',
  'text-only': 'fe-text-only',
  'password': 'fe-password',
  'text': 'fe-text',
  'select': 'fe-select',
  'switch': 'fe-switch',
  'checkbox': 'fe-checkbox',
  'radio': 'fe-radio',
  'single-date-picker': 'fe-single-date-picker',
  'double-date-picker': 'fe-double-date-picker',
  'common-tree': 'fe-common-tree',
  'range': 'fe-range',
  'inputDia': 'fe-inputDia',
  'timeLine': 'fe-time-line',
  'uploadCdn': 'fe-uploadCdn',
  'area': 'fe-area',
  'multiple-report': 'multiple-report',
  'single-report': 'single-report',
  'week-picker': 'fe-weekPicker',
  'month-picker': 'fe-monthPicker',
  'area-select': 'fe-area-select-group',
  'select-bi': 'fe-select-bi'
}



// WEBPACK FOOTER //
// ./src/utils/report.js